import React, { useEffect, useState } from 'react';

function TenantsScreen({ token, onSelectTenant }) {
  const [tenants, setTenants] = useState([]);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Cargar tenants al montar
  useEffect(() => {
    fetchTenants();
    // eslint-disable-next-line
  }, []);

  const fetchTenants = async () => {
    setLoading(true);
    setError('');
    try {
  const res = await fetch('https://api.braineka.com/tenants', {
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al cargar tenants');
      setTenants(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    try {
  const res = await fetch('https://api.braineka.com/tenants', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        },
        body: JSON.stringify({ nombre, descripcion })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al crear tenant');
      setNombre('');
      setDescripcion('');
      fetchTenants();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="tenants-container">
      <h3>Tenants</h3>
      <form onSubmit={handleCreate} className="tenant-form">
        <input
          type="text"
          placeholder="Nombre del tenant"
          value={nombre}
          onChange={e => setNombre(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Descripción"
          value={descripcion}
          onChange={e => setDescripcion(e.target.value)}
        />
        <button type="submit">Crear tenant</button>
      </form>
      {error && <div className="tenant-error">{error}</div>}
      {loading ? <div>Cargando...</div> : (
        <ul className="tenant-list">
          {tenants.map(t => (
            <li key={t.id}>
              <b>{t.nombre}</b> <span>{t.descripcion}</span>
              <button onClick={() => onSelectTenant(t)}>Seleccionar</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default TenantsScreen;
